/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Standard check-in and check-out time
 * @export
 * @interface TravelinePolicyInfoDto
 */
export interface TravelinePolicyInfoDto {
    /**
     * Local check-in time at the property.<br />
     * Tome format complies with ISO-8601 hh:mm
     * @type {string}
     * @memberof TravelinePolicyInfoDto
     */
    checkInTime: string;
    /**
     * Local check-out time at the property.<br />
     * Tome format complies with ISO-8601 hh:mm
     * @type {string}
     * @memberof TravelinePolicyInfoDto
     */
    checkOutTime: string;
}

/**
 * Check if a given object implements the TravelinePolicyInfoDto interface.
 */
export function instanceOfTravelinePolicyInfoDto(value: object): value is TravelinePolicyInfoDto {
    if (!('checkInTime' in value) || value['checkInTime'] === undefined) return false;
    if (!('checkOutTime' in value) || value['checkOutTime'] === undefined) return false;
    return true;
}

export function TravelinePolicyInfoDtoFromJSON(json: any): TravelinePolicyInfoDto {
    return TravelinePolicyInfoDtoFromJSONTyped(json, false);
}

export function TravelinePolicyInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelinePolicyInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'checkInTime': json['checkInTime'],
        'checkOutTime': json['checkOutTime'],
    };
}

  export function TravelinePolicyInfoDtoToJSON(json: any): TravelinePolicyInfoDto {
      return TravelinePolicyInfoDtoToJSONTyped(json, false);
  }

  export function TravelinePolicyInfoDtoToJSONTyped(value?: TravelinePolicyInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkInTime': value['checkInTime'],
        'checkOutTime': value['checkOutTime'],
    };
}

